import React from "react";
import { PieChart, Pie, Cell, ResponsiveContainer } from "recharts";
import { Typography } from "../../Components/Typography";

// Ideas at Various Stages - 5 stages (Spark, Shape, Structure, Scale, Shine)
export const IDEAS_STAGES_DATA = [
  { label: "Spark", value: 0 },
  { label: "Shape", value: 0 },
  { label: "Structure", value: 0 },
  { label: "Scale", value: 0 },
  { label: "Shine", value: 0 },
];

const STAGE_COLORS = {
  Spark: "#EC4899",
  Shape: "#22C55E",
  Structure: "#F97316",
  Scale: "#8B5CF6",
  Shine: "#38BDF8",
};

export const IdeasDonutChart = ({ data = IDEAS_STAGES_DATA }) => {
  const colors = data.map((item) => STAGE_COLORS[item.label] || "#94A3B8");
  return (
    <div className="flex items-center gap-6">
      <div className="relative w-32 h-32 flex-shrink-0">
        <ResponsiveContainer width="100%" height="100%">
          <PieChart>
            <Pie
              data={data}
              cx="50%"
              cy="50%"
              labelLine={false}
              outerRadius={40}
              innerRadius={25}
              fill="#8884d8"
              dataKey="value"
              startAngle={90}
              endAngle={-270}
            >
              {data.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={colors[index]} />
              ))}
            </Pie>
          </PieChart>
        </ResponsiveContainer>
      </div>
      <div className="flex flex-col gap-2">
        {data.map((item, index) => (
          <div key={item.label} className="flex items-center gap-2">
            <div
              className="w-3 h-3 rounded-full flex-shrink-0"
              style={{ backgroundColor: STAGE_COLORS[item.label] || "#94A3B8" }}
            />
            <Typography as="p" className="text-sm text-slate-700">
              {item.label}
            </Typography>
            <Typography as="p" className="text-sm font-semibold text-slate-900 ml-auto">
              {item.value}
            </Typography>
          </div>
        ))}
      </div>
    </div>
  );
};
